import CardAuthor from "./CardElements/CardAuthor";
import CardCategory from "./CardElements/CardCategory";
import CardSocials from "./CardElements/CardSocials";
import CardStatChart from "./CardElements/CardStatChart";
import CardBorderlessChart from "./CardElements/CardBorderlessChart";
import CardStat from "./CardElements/CardStat";

import Button from "./CustomButton/CustomButton";

import Checkbox from "./CustomCheckbox/SimpleCheckbox";

import Radio from "./CustomRadio/CustomRadio";

import Footer from "./Footer/Footer";

import FormInputs from "./FormInputs/FormInputs";

import Header from "./Header/Header";

import PanelHeader from "./PanelHeader/PanelHeader";

import Sidebar from "./Sidebar/Sidebar";

import Stats from "./Stats/Stats";

import Tasks from "./Tasks/Tasks";

import NewReloadModal from "./Modals/NewReloadModal";

export {
  // CardElements
  CardAuthor,
  CardCategory,
  CardSocials,
  CardStatChart,
  CardBorderlessChart,
  CardStat,
  // CustomButton
  Button,
  // CustomCheckbox
  Checkbox,
  // CustomRadio
  Radio,
  // Footer
  Footer,
  // FormInputs
  FormInputs,
  // Header
  Header,
  // PanelHeader
  PanelHeader,
  // Sidebar
  Sidebar,
  // Stats
  Stats,
  // Tasks
  Tasks,
  // Modals
  NewReloadModal
};



// WEBPACK FOOTER //
// ./src/components/index.js